
import React from 'react';
import styled from 'styled-components';
import ScrollWildfires from '../../components/ScrollWildfires/ScrollWildfires';
import ScrollIcemin from '../../components/ScrollIcemin/ScrollIcemin';
import ScrollCoral from '../../components/ScrollCoral/ScrollCoral';
import ScrollPollution from '../../components/ScrollPollution/ScrollPollution';
import {Link} from 'react-router-dom';


const Container = styled.div`
  display: flex;
  width: auto;
  height:auto;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow-x: scroll;


  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
 }
  
`;

const Box = styled.div`
  flex-shrink: 0 ;
  flex: 0 0 auto;
  width:200px;
  height:170px;
  padding:10px;
  background-color:#000;
  border-radius:9px;
  opacity:50%;
`;

const Impactwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s; 
}
`;
const Space = styled.div`
  margin:0px;
  @media (max-width: 768px) {
    margin:7px;

  }
`;

class CarouselTrending extends React.Component {

  render () {
   return (

  <Container >
    <Space/>
    <Impactwrapper><Link to="/Land_Forestfires"><ScrollWildfires/></Link></Impactwrapper>
    <Impactwrapper><Link to="/Land_Arctic-ice-minimum"><ScrollIcemin/></Link></Impactwrapper> 
    <Impactwrapper><Link to="/Oceans_Coral-reefs"><ScrollCoral/></Link></Impactwrapper> 
    <Impactwrapper><Link to="/Oceans_Plastic-pollution"><ScrollPollution/></Link></Impactwrapper> 
  </Container>
  );
 }
}
export default CarouselTrending;
